import React from 'react';
import { useTooltipBehavior } from '../shared';
import { TooltipWrapper, TooltipPane, TooltipPointerSpace } from '../styles';

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      targetElement = _ref.targetElement,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottomRight' : _ref$position,
      className = _ref.className,
      open = _ref.open,
      dataTest = _ref['data-test'];

  var _useTooltipBehavior = useTooltipBehavior(targetElement, open),
      isTooltipShown = _useTooltipBehavior.isTooltipShown,
      onMouseLeaveWrapper = _useTooltipBehavior.onMouseLeaveWrapper,
      extendedTargetElement = _useTooltipBehavior.extendedTargetElement,
      wrapperRef = _useTooltipBehavior.wrapperRef;

  return /*#__PURE__*/React.createElement(TooltipWrapper, {
    onMouseLeave: onMouseLeaveWrapper,
    className: className,
    ref: wrapperRef,
    "data-test": dataTest ? "".concat(dataTest, "-wrapper") : undefined
  }, extendedTargetElement, /*#__PURE__*/React.createElement(TooltipPane, {
    isShown: isTooltipShown,
    position: position,
    role: "tooltip",
    "data-test": dataTest ? dataTest : undefined
  }, children, /*#__PURE__*/React.createElement(TooltipPointerSpace, {
    position: position
  })));
};

export default Tooltip;